<script>
    import Time from 'svelte-time';
</script>

<footer class="text-muted py-3 bg-light mt-3 border-top border-primary">
    <div class="container-fluid text-center clearfix">
        <small class="float-end">
            <a href='https://binaryio.cloud' target='_blank'>
                <span class="fas fa-copyright"></span> binaryIO <Time timestamp="{new Date()}" format="YYYY"/>
            </a>
        </small>

        <a href='https://www.scorpionsvolleyball.club/' target='_blank' class='float-start'> 
            <img src='/images/ScorpsLogo.png' class='img-responsive scorps-logo' style='width: 125px; height: 125px;' alt='Scorpions Volleyball'/>
        </a>
    </div>
</footer>
<div class="border-bottom border-warning"></div>